import { getUrlAPIv3, getUrlAPIv4 } from '../api';
import { Root } from '../model/banners.model';
import { Root as UserModel } from '../model/user.model';

const getPromotion = async (idPromotion: string): Promise<Root | null> => {
    let url = `${getUrlAPIv3}/promotions/byPromotionId/${idPromotion}`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });
        if (response.status === 200) {
            const data = await response.json();
            return data;
        }
        return null;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export default getPromotion;